import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const monthlyIncomeFeatureKey = 'monthlyIncome';

export interface MonthlyIncomeState {
  loadMonthlyIncome: any;
  loadMonthlyIncomeResponse: any;
  loadMonthlyIncomeFailure: any;
}

export const initialState: MonthlyIncomeState = {
  loadMonthlyIncome: undefined,
  loadMonthlyIncomeResponse: undefined,
  loadMonthlyIncomeFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(actions.loadMonthlyIncome, (state, action) => ({
    ...state,
    loadMonthlyIncome: action.request
  })),
  on(actions.loadMonthlyIncomeSuccess, (state, action) => ({
    ...state,
    loadMonthlyIncomeResponse: action.response
  })),
  on(actions.loadMonthlyIncomeFailure, (state, action) => ({
    ...state,
    loadMonthlyIncomeFailure: action.error
  }))
);

export const getMonthlyIncome = (state: MonthlyIncomeState) => state.loadMonthlyIncomeResponse;
